import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ArrowDown from '../../assets/icons/arrowDown';
import classes from './style.module.scss';

export default function Dropdown({
  placeHolder = '',
  list = [],
  onChange,
  value = '',
  isAllOptionActive
}) {
  const { t } = useTranslation();

  const handleClick = (e, item) => {
    e.preventDefault();
    onChange(item.value);
  };

  const activeItem = list.find((item) => item.value === value);

  return (
    <div className={classes.container}>
      <div className={classes.button}>
        {activeItem?.label || placeHolder}
        <ArrowDown />
      </div>
      <div className={classes.list}>
        {isAllOptionActive && (
          <a href="/" onClick={(e) => handleClick(e, '')}>
            {t('search_all')}
          </a>
        )}
        {list.map((item, index) => (
          <a key={index.toString()} href="/" onClick={(e) => handleClick(e, item)}>
            {item.label}
          </a>
        ))}
      </div>
    </div>
  );
}

Dropdown.defaultProps = {
  isAllOptionActive: false,
  value: null
};

Dropdown.propTypes = {
  placeHolder: PropTypes.string.isRequired,
  value: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  isAllOptionActive: PropTypes.bool
};
